import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {computed, observable} from "mobx";
import FirebaseMyAccountService from "src/services/firebase/functions/FirebaseMyAccountFunctionsService";

export class ReplaceCardStore extends ApiCallObservable {
    // Kind of a hack, because signup store propagate errors through specific fields.
    @observable public paymentError: string | boolean = false;
    // Unused fields but this is currently a must because FormPayment access those directly. Should be refactored
    public formInput = {};
    public navigationController = {};
    @observable public isVerified: boolean = false;
    @observable public files = {};
    @observable public _monthlyPaymentAmount: number = -1;
    @observable public showFinishPaymentAnimation: boolean = false;
    private cardInfo : any;

    public updatePayment = async (data: any) =>  {
        this.cardInfo = { opaqueData : data };
        return this.submit();
    };

    public fetchData = async () => {
        try {
            this.setSending();
            const response = await FirebaseMyAccountService.getMemberOutstandingBalance();
            if (response.ok) {
                this._monthlyPaymentAmount = response.data.totalPaymentAmount
                this.setSuccessfulResponse(response.data);
            } else {
                this.setError(response.error && response.error!.message ? response.error!.message! : "Failed fetching payment amount");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    };

    public setReplaceCardMode() {
        this._monthlyPaymentAmount = 0
        this.isVerified = false
    }
    public setPaymentMode() {
        this.fetchData()
        this.isVerified = true
    }

    @computed
    get isInitialized() {
        return this._monthlyPaymentAmount !== -1 || this.isSending;
    };

    @computed
    get getmonthlyPaymentAmount() {
        return this._monthlyPaymentAmount;
    };

    public async submit() {
        try {
            this.setSending();
            const response = this.isVerified ? 
            await FirebaseMyAccountService.payMemberOutstandingBalance(this.cardInfo)
            :
            await FirebaseMyAccountService.replacePaymentMethod(this.cardInfo);

            if (response.ok) {
                this.setSuccessfulResponse(response.data);
                this.showFinishPaymentAnimation = true;
            } else {
                this.paymentError = "Card verification failed. Please check your information and try again.";
                this.setError(response.error && response.error!.message ? response.error!.message! : "Unknown Error");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
            this.paymentError = true
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/scenes/MyAccount/state/mobx/ReplaceCardStore.ts